import axios from 'axios';
// eslint-disable-next-line import/named
import { applyBearerOrCookie } from './authStrategy';
import store from './store';

export const { VUE_APP_SECURITY_SERVICE_URL } = process.env;

const securityRequest = (config, explicitToken) => {
  const resolvedAccessTokenForAuth = explicitToken === undefined ? store.getToken() : explicitToken;
  return axios(applyBearerOrCookie(config, resolvedAccessTokenForAuth));
};

const findAllDriveDefaultTemplates = (token) => {
  const url = `${VUE_APP_SECURITY_SERVICE_URL}/drive_default_template`;
  return securityRequest({
    url,
    method: 'get',
  }, token);
};

const findAllDriveEmailTemplates = (token) => {
  const url = `${VUE_APP_SECURITY_SERVICE_URL}/drive_email_template`;
  return securityRequest({
    url,
    method: 'get',
  }, token);
};

const findAllProfilesByAppCode = (token) => {
  const url = `${VUE_APP_SECURITY_SERVICE_URL}/profile/findAllByAppCode`;
  return securityRequest({
    url,
    method: 'get',
  }, token);
};

export {
  findAllDriveDefaultTemplates,
  findAllDriveEmailTemplates,
  findAllProfilesByAppCode,
};
